module.exports = __webpack_public_path__ + "static/death-a0f0f643ab4332fe4fc14b1144069cf8.jpg";